import React, { useState, useEffect } from 'react';
import ParentsHeroForm from './ParentsHeroForm';
import ParentsLearningCommunityForm from './ParentsLearningCommunityForm';
import ParentsHandbookForm from './ParentsHandbookForm';
import ParentsPortalForm from './ParentsPortalForm';
import ParentsCommunicationForm from './ParentsCommunicationForm';
import { 
  Users, 
  HeartHandshake, 
  BookOpen, 
  Laptop, 
  MessageSquare 
} from 'lucide-react';
import './FormsUnified.css';

const TABS = [
  { id: 'hero', title: 'Hero Section', icon: Users, component: ParentsHeroForm },
  { id: 'palc', title: 'Learning Community (PaLC)', icon: HeartHandshake, component: ParentsLearningCommunityForm },
  { id: 'handbook', title: 'Parent Handbook', icon: BookOpen, component: ParentsHandbookForm },
  { id: 'portal', title: 'Portal Access', icon: Laptop, component: ParentsPortalForm },
  { id: 'communication', title: 'Communication Channels', icon: MessageSquare, component: ParentsCommunicationForm }
];

export default function ParentsForm({ apiBase, activeTab }) {
  const getInitialTab = () => {
    if (activeTab === 'cms-par-palc' || activeTab === 'parents-palc') return 'palc';
    if (activeTab === 'cms-par-handbook' || activeTab === 'parents-handbook') return 'handbook';
    if (activeTab === 'cms-par-portal' || activeTab === 'parents-portal') return 'portal';
    if (activeTab === 'cms-par-communication' || activeTab === 'parents-communication') return 'communication';
    return 'hero';
  };

  const [currentTab, setCurrentTab] = useState(getInitialTab);

  useEffect(() => {
    setCurrentTab(getInitialTab());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [activeTab]);

  const activeTabConfig = TABS.find(t => t.id === currentTab) || TABS[0];
  const ActiveComponent = activeTabConfig.component;

  return (
    <div className="unified-master-container">
      {/* Tab Navigation Pill Bar */}
      <div className="unified-tab-bar">
        {TABS.map((tab) => {
          const Icon = tab.icon;
          const isActive = tab.id === currentTab;

          return (
            <button
              key={tab.id}
              type="button"
              className={`tab-pill-btn ${isActive ? 'active' : ''}`}
              onClick={() => setCurrentTab(tab.id)}
            >
              <Icon className="w-4 h-4 mr-2" size={16} />
              <span>{tab.title}</span>
            </button>
          );
        })}
      </div>

      {/* Render Active Section Sub-Form */}
      <div className="unified-tab-content">
        <ActiveComponent apiBase={apiBase} />
      </div>
    </div>
  );
}
